import styled from 'styled-components';

export const DownloadWrapper = styled.div`
  margin-right: 15px;
`;
